import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/ducks/session";

const Nav = (props) => {
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.session.userID);
  //const userName = useSelector((state) => state.user.users[userID]?.userName);
  //const firstName = useSelector((state) => state.user.users[userID]?.firstName);

  const user = useSelector((state) => state.user.users[userID]);
  const userName = user?.userName;
  const firstName = user?.firstName;
  const lastName = user?.lastName;

  const performLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="nav-container">
      <nav className="nav">
        <div className="nav__item">
          <a className="cat-name" href="/">
            Scriben
          </a>
        </div>

        {props.children}

        <div className="nav__right">
          <div className="nav__item">{firstName}</div>

          <button className="nav__button button" onClick={performLogout}>
            <i class="fas fa-sign-out-alt"></i>
            <span> Logout</span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Nav;
